// @flow
import type { Saga } from 'redux-saga'
import { fork } from 'redux-saga/effects'

import { apiSaga } from '@modules/api'
import { authSaga } from '@modules/auth'
import { appshellSaga } from '@modules/appshell'
import { cartSaga } from '@modules/cart'
import { checkoutSaga } from '@modules/checkout'

export const STORE_SAGAS_SUCCESS: string = '@@sagas/STORE_SAGAS_SUCCESS'

export const combineSagas = function * (): Saga<void> {
  yield fork(apiSaga)
  yield fork(authSaga)
  yield fork(appshellSaga)
  yield fork(cartSaga)
  yield fork(checkoutSaga)

  yield STORE_SAGAS_SUCCESS
}
